<template>
  <div>
    <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
      <ul class="navbar-nav">
        <template v-for="(group_menu, index_group) in data" :key="index_group">
          <li>
            <span
              class="mx-4 text-sm fw-bold"
              v-if="!['dashboard','other'].includes(group_menu?.label?.toLocaleLowerCase())"
            >
              {{ group_menu?.label || '-' }}
            </span>
          </li>
          <li v-for="(item, index) in group_menu.menu" :key="index" class="nav-item">
            <sidenav-item
              :hasSub="(item?.sub ?? []).length > 0"
              :url="item.slug"
              :navText="item.title"
              :icon="item.icon"
              v-if="item?.status === null || (item?.status !== null && item?.status === true)"
            >
            </sidenav-item>
            <ul v-if="item?.sub">
              <li
                v-show="this.$store.state.currentPath.startsWith(item.slug) || this.$route.path.startsWith(item.slug)"
                v-for="(itemsub, index) in item.sub"
                :key="index"
                class="nav-item"
              >
                <sidenav-item
                  :url="itemsub.slug"
                  :navText="itemsub.title"
                  isSub
                  v-if="itemsub?.status === null || (itemsub?.status !== null && itemsub?.status === true)"
                >
                </sidenav-item>
              </li>
            </ul>
          </li>
          <hr class="mx-4 my-3" v-if="(index_group + 1) !== data.length">
        </template>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.navbar-nav ul {
  list-style-type: none;
  padding-left: 0;
}
</style>
<script>
import SidenavItem from "./SidenavItem.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      data: []
    };
  },
  watch: {
    '$store.state.sessionUser': {
      handler: function () {
        this.setMenuData();
      },
      deep: true,
    },
  },
  methods: {
    checkSlug(slug) {
      if (slug?.toLocaleLowerCase()?.substr(0, 4) === '/kye') {
        slug = `${window.location.origin}${slug}`
      }
      return slug
    },
    setMenuData() {
      let all_menus = []
      if (this.$store?.state?.sessionUser?.new_menus?.length > 0 && this.data?.length === 0) {
        all_menus = JSON.parse(JSON.stringify(this.$store?.state?.sessionUser?.new_menus)) || []
        all_menus.forEach((all_menu_item, index) => {
          all_menus[index].menu = all_menus[index].menu.map((item) => {
            return {
              title: item.title ?? '',
              slug: this.checkSlug('/' + item.slug),
              icon: item.icon ?? 'fa-solid fa-desktop',
              sub: item?.submenu?.map((sub) => {
                return {
                  title: sub.title ?? '',
                  slug: this.checkSlug(sub?.slug?.substr(0, 4) === 'kye/' ? '/' + sub.slug : ('/' + item.slug + '/' + sub.slug)),
                  icon: sub.icon ?? 'fa-solid fa-desktop',
                  status: sub.status ?? null,
                }
              }),
              status: item.status ?? null,
            }
          })
        });
        this.data = all_menus;
      }
    }
  },
  mounted() {
    this.setMenuData();
  },
  components: {
    SidenavItem,
  },
};
</script>
